import {action} from "mobx";

import apiRequestService from "../services/apiRequestService";
import appStore from "./appStore";
import i18n from "../i18n";
class apiRequestStore {
    @action getAuthToken = async params => {
        const resultOfRequest = await apiRequestService.getAuthToken(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest?.data?.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    @action getCompanyInfo = async params => {
        const resultOfRequest = await apiRequestService.getCompanyInfo(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest?.data?.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    @action calculatePrice = async params => {
        const resultOfRequest = await apiRequestService.calculatePrice(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest?.data?.message});
            return resultOfRequest;
        }
        return resultOfRequest;
    };
    @action createDelivery = async params => {
        appStore.setLoading(true);
        let resultOfRequest = await apiRequestService.createDelivery(params);

        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest?.data?.message});
            appStore.setLoading(false);
            return resultOfRequest;
        } else {
            let message = resultOfRequest.data.deliveryId;
            const deliveryState = resultOfRequest.data.deliveryState;
            if (deliveryState == "inQueue") {
                message = i18n.t("stores.apiRequest.createDelivery.addToQueue", {
                    ns: "common",
                    message: message
                });
            } else if (deliveryState == "inSlot") {
                message = i18n.t("stores.apiRequest.createDelivery.createdSlot", {
                    ns: "common",
                    message: message
                });
            } else {
                message = i18n.t("stores.apiRequest.createDelivery.created", {
                    ns: "common",
                    message: message
                });
            }
            await appStore.showSuccessMessage({
                content: message
            });
        }
        appStore.setLoading(false);
        return resultOfRequest;
    };
}

export default new apiRequestStore();
